<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20 20H4C3.46957 20 2.96086 19.7893 2.58579 19.4142C2.21071 19.0391 2 18.5304 2 18V15C2.79565 15 3.55871 14.6839 4.12132 14.1213C4.68393 13.5587 5 12.7956 5 12C5 11.2044 4.68393 10.4413 4.12132 9.87868C3.55871 9.31607 2.79565 9 2 9V6C2 5.46957 2.21071 4.96086 2.58579 4.58579C2.96086 4.21071 3.46957 4 4 4H20C20.5304 4 21.0391 4.21071 21.4142 4.58579C21.7893 4.96086 22 5.46957 22 6V9C21.2044 9 20.4413 9.31607 19.8787 9.87868C19.3161 10.4413 19 11.2044 19 12C19 12.7956 19.3161 13.5587 19.8787 14.1213C20.4413 14.6839 21.2044 15 22 15V18C22 18.5304 21.7893 19.0391 21.4142 19.4142C21.0391 19.7893 20.5304 20 20 20Z"
      fill="#3CB149"
    />
    <path
      d="M9.07172 16L12.0017 14.12L14.9317 16L14.0417 12.64L16.7317 10.44L13.2617 10.23L12.0017 7L10.7317 10.22L7.26172 10.43L9.95172 12.63L9.07172 16Z"
      fill="#FFC304"
    />
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
